app.service('NotificationService', [
    '$rootScope',
    '$timeout',
    '$sce',
    'NotificationAPI',
    'Session',
    '$modal',
    '$sanitize',
    function ($rootScope, $timeout, $sce, NotificationAPI, Session, $modal, $sanitize) {
        let current = null;
        let queue = [];
        let modalInstance = null;
        let bannerTimer = null;

        function broadcast() {
            $rootScope.$broadcast('notificationChanged');
        }

        this.getCurrent = () => current;

        this.show = (notification, msg, type = 'STANDARD', ms = 5000) => {
            current = { message: msg, title: notification.title, type, duration: ms, notification_id: notification.notification_id };
            broadcast();
            // One timer per banner, cancelled when the banner is dismissed early - otherwise it fired
            // later against whatever banner was showing by then and skipped it.
            $timeout.cancel(bannerTimer);
            bannerTimer = ms ? $timeout(() => this.clear(notification.notification_id), ms) : null;
        };

        this.clear = (notification_id) => {
            $timeout.cancel(bannerTimer);
            bannerTimer = null;
            if (modalInstance) {
                modalInstance.hide();
                modalInstance = null;
            }
            // The banner sits outside the routed views, so it can outlive a logout.
            if (Session.user) {
                NotificationAPI.setNotificationViewedByUser(notification_id, Session.user.id);
            }
            current = null;
            broadcast();
            this._showNext();
        };

        // Fetch & enqueue
        this.loadPending = () => {
            NotificationAPI
                .getPendingNotificationsForUser(Session.userId)
                .then(resp => {
                    // 1️ pathway (MODAL before BANNER)
                    const pathwayRank = { MODAL: 0, BANNER: 1 };

                    // 2️ urgency within each pathway (URGENT → ERROR → HIGH → STANDARD)
                    const urgencyRank = ['URGENT', 'ERROR', 'HIGH', 'STANDARD']
                        .reduce((m, v, i) => { m[v] = i; return m; }, {});

                    // Called again while one is on screen (e.g. after legal agreements clear), the
                    // displayed notification must not be queued a second time.
                    const showingId = modalInstance ? modalInstance.$scope && modalInstance.$scope.notification && modalInstance.$scope.notification.notification_id
                        : current && current.notification_id;
                    queue = (resp.data || [])
                        .filter(n => !showingId || n.notification_id !== showingId)
                        .sort((a, b) => {
                            // pathway first
                            const diffPath = pathwayRank[a.notification_pathway_type] -
                                pathwayRank[b.notification_pathway_type];
                            if (diffPath !== 0) return diffPath;

                            // urgency second (only runs if both are same pathway)
                            const diffUrg = urgencyRank[a.notification_urgency_type] -
                                urgencyRank[b.notification_urgency_type];
                            if (diffUrg !== 0) return diffUrg;

                            // newest first as final tie-breaker
                            return Date.parse(b.date_created || 0) -
                                Date.parse(a.date_created || 0);
                        });

                    // Only start the queue if nothing is showing; the current one advances it when it closes.
                    if (!modalInstance && !current) {
                        this._showNext();
                    }
                })
                .catch(err => console.error('Error fetching notifications:', err && err.status));
        };

        // Dequeue + render
        this._showNext = () => {
            if (!queue.length) return;

            const notification = queue.shift();
            // Sanitised before it is trusted: the message is authored HTML, and trusting it raw let any
            // script or event-handler markup in it run in every recipient's session.
            notification.trustedMessage = $sce.trustAsHtml($sanitize(notification.message || ''));

            if (notification.notification_pathway_type === 'MODAL') {
                // create a fresh scope so template can bind to `notification`
                const modalScope = $rootScope.$new();
                modalScope.notification = notification;

                modalInstance = $modal({
                    scope: modalScope,
                    templateUrl: 'app/src/views/templates/notifications/modal.notification.tpl.html',
                    show: true,
                    backdrop: 'static',
                    keyboard: false,
                    onHide: () => {
                        modalInstance = null;
                        NotificationAPI.setNotificationViewedByUser(modalScope.notification.notification_id, Session.user.id);
                        modalScope.$destroy();
                        this._showNext();
                    }
                });
                modalScope.notificationModal = modalInstance;

            } else if (notification.notification_pathway_type === 'BANNER') {
                this.show(
                    notification,
                    notification.trustedMessage,
                    notification.notification_urgency_type,
                    5000
                );
            }
        };
    }
]);
